/**
 * @param {$axios实例} $axios
 * @param {请求配置} opt{
 *                      requestType请求类型：1:带有token认证的请求,并且使用弹窗loading
 *                                          2:带有token认证的请求,并且使用弹窗loading,401特殊处理
 *                                          3:一般请求,并且使用弹窗loading
 *                                          4:带有token认证的请求，无loading,401特殊处理
 *                                          5:带有token认证的请求，无loading
 *                                          6:一般请求，无loading,
 *                      url：请求url,
 *                      param:请求参数
 *                  }
 */
/**
   AaronXue <xch1523480@gmail.com>
   2018.4.26
   二次封装axios请求,添加loading
   通过qs.stringify()将对象 序列化成URL的形式，以&进行拼接
*/
import axios from 'axios'
import { getCookie, navigateToApp, clearCookie, getWXEvn, setCookie, isBangBangApp, isAndroid, isIOS, isWeixin, getQueryString, checkPhoneNo } from './index'
import { Toast, Dialog } from 'vant';
import { api, h5 } from "./env";
import wx from "@/assets/js/jweixin-1.6.0";
import Vue from 'vue'
import Verify from "../components/verifition/Verify.vue";

const http = options => {
  let $Toast = null
  return new Promise((resolve, reject) => {
    const defaultOptions = {};
    const newOptions = {
      ...defaultOptions,
      ...options
    };
    switch (newOptions.requestType) {
      case 1:
      case 3:
        $Toast = Toast.loading({
          duration: 0,
          message: '请求中...',
          forbidClick: true,
        });
        break;
      case 2:
      case 4:
      case 5:
      case 6:

        break;
    }
    //headers默认传递json格式数据，这里也可以设置token，每次调用都会携带
    newOptions.headers = {
      'content-Type': 'application/json;charset=UTF-8',
      'PLATFORM': 'webH5',
      'VERSION': '3.0.19',
      ...newOptions.headers
    };
    if (newOptions.requestType !== 3 && newOptions.requestType !== 6) {
      newOptions.headers['access_token'] = getCookie('token')
    }
    //这里可以在调用的时候看到你的method、url、data、headers等参数
    //console.log(newOptions);
    axios({
      method: newOptions.method,
      url: newOptions.url,
      data: newOptions.data,
      params: newOptions.params,
      headers: newOptions.headers
    }).then(res => {
      //根据返回的状态码判断，注意res返回的并不一定都是status，比如小程序就是statusCode
      switch (newOptions.requestType) {
        case 1:
        case 3:
          $Toast.clear()
          break;
        case 2:
        case 4:
        case 5:
        case 6:
          break;
      }
      if (res.status === 200) {
        //这里我们只需要获取返回的data中的数据即可
        resolve(res.data);
      } else {
        Dialog.alert({
          title: '温馨提示',
          message: res.data.message,
          confirmButtonColor: "#fb3e47",
        })
        reject(res);
      }
    }).catch(err => {
      if (newOptions.requestType === 1 || newOptions.requestType === 3) {
        $Toast.clear()
      }
      if (err === undefined || err.code === 'ECONNABORTED') {
        Dialog.alert({
          title: '温馨提示',
          message: '服务请求超时',
          confirmButtonColor: "#fb3e47",
        })
        reject(err)
        return
      }
      const status = err.response.status
      switch (status) {
        case 400:
        case 404:
        case 406:
        case 410:
        case 422:
          Dialog.alert({
            title: '温馨提示',
            message: '发出的请求有错误',
            confirmButtonColor: "#fb3e47",
          })
          break;
        case 401:
        case 403:
          clearCookie('token')
          clearCookie('userId')

          if (newOptions.requestType === 2 || newOptions.requestType === 4) {
            if (newOptions.hasOwnProperty('loginFail')) {
              newOptions.loginFail && newOptions.loginFail()
              return
            }
            toLogin()
          }
          break;
        case 500:
        case 502:
        case 503:
        case 504:
          Dialog.alert({
            title: '温馨提示',
            message: '服务器发生错误!',
            confirmButtonColor: "#fb3e47",
          })
          break;
        default:
          break;
      }
      reject(err);
    })
  })
}



const toLogin = () => {
  clearCookie('token')
  clearCookie('userId')
  if (isWeixin()) {
    getWXEvn({
      //如果是小程序
      isMiniApp: () => {
        const str = location.href; //取得整个地址栏
        const strList = str.split("?");
        const arr = strList[1] ? strList[1].split("&").filter(item => {
          return !(item.includes('access_token') || item.includes('userId'))
        }) : []
        wx.miniProgram.navigateTo({
          url: `/pages/authorize/authorize?from=commonh5&redirectUrl=${strList[0]}?${arr.join('&')}`,
        });
      },
      //如果是公众号网页
      isWeixinNotMiniApp: () => {
        openLoginPop()
      }
    });
  } else if (isBangBangApp()) {
    //在app中
    navigateToApp('szbb://weex/login.js?swipeBack=false')
  } else {
    openLoginPop()
  }
}
const openLoginPop = () => {
  Dialog.confirm({
    message:
      '<form class="register_form" action="">' +
      '<div class="input_control">' +
      '<input type="number" placeholder="手机号" name="phoneNum" />' +
      "</div>" +
      '<div class="input_control">' +
      '<input type="number" placeholder="手机验证码" name="code" />' +
      '<span class="sendCode">获取验证码</span>' +
      "</div>" +
      '<div class="login_agree">' +
      '<label for="isAgreee">' +
      '<input id="isAgreee" type="checkbox" name="isAgreee"/>' +
      '<div class="show-box"></div>' +
      '</label>' +
      '<span>我已阅读并同意</span>' +
      '<span class="link link1">《用户协议》</span>' +
      '<span class="link link2">《隐私政策》</span>' +
      "</div>" +
      "</form>",
    confirmButtonText: "登录/注册",
    confirmButtonColor: "#fb3e47",
    // showCancelButton: false,
    beforeClose(action, done) {
      var $register_form = $('.register_form')
      var phoneNo = $register_form.serializeArray()[0].value
      var code = $register_form.serializeArray()[1].value
      done(false)
      if (action === 'confirm') {
        if (!checkPhoneNo(phoneNo)) {
          Toast('手机号码错误')
          return
        }
        if (code === "") {
          Toast("请输入验证码");
          return;
        }
        if (!$register_form.serializeArray()[2]) {
          Toast("请阅读并同意《用户协议》与《隐私政策》");
          return
        }
        get({
          url: api + 'api/v2/engineer/register.json',
          data: {
            phonenumber: phoneNo,
            code: code,
            version: '3.0.20',
            reg_source: getQueryString('utm_source') || 'webH5'
          },
          requestType: 3
        }).then(data => {
          if (data.result === "success") {
            setCookie("token", data.body.access_token, 365 * 24 * 60 * 60);
            setCookie("userId", data.body.userId, 365 * 24 * 60 * 60);
            location.reload()
          } else {
            Toast(data.message)
          }
        })
      } else {
        Dialog.close()
      }
    },
  })
  setTimeout(() => {
    $('input').off('blur')
    $('.link1').off('click')
    $('.link2').off('click')
    $('.sendCode').off('click')
    $('input').on('blur', function () {
      var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
      window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      document.activeElement.scrollIntoViewIfNeeded(true);
    })
    $('.link1').on('click', () => {
      location.href = `${h5}app/register/register_e.html`
    })
    $('.link2').on('click', () => {
      location.href = `https://c.shenzhoubb.com/article/1575881359388`
    })
    const verify = new Vue({
      render: h => {
        return h(Verify, {
          ref: 'verify',
          props: {
            mode: 'pop',
            captchaType: 'blockPuzzle',
            imgSize: { width: '330px', height: '155px' }
          }
        })
      },
    }).$mount('#verify_w')
    //发送验证码
    var $sendCode = $('.sendCode');
    var $register_form = $('.register_form')
    var isSend = false;
    var count = 60;
    function jishi() {
      isSend = true;
      if (count === 0) {
        $sendCode.text('重新发送验证码');
        isSend = false;
        count = 60;
        return;
      }
      count--;
      $sendCode.text('剩余' + count + 's')
      setTimeout(function () {
        jishi();
      }, 1000)
    }
    $sendCode.on('click', function () {
      if (!isSend) {
        var phoneNo = $register_form.serializeArray()[0].value
        if (!checkPhoneNo(phoneNo)) {
          Toast('手机号码错误')
          return
        }
        verify.$refs.verify.show().then(res => {
          post({
            url: api + 'api/SMSVerification/sendSMS',
            data: {
              accessPhonenumber: phoneNo,
              captchaVerification: res.captchaVerification,
              useInterface: '/api/v2/engineer/register.json'
            },
            requestType: 3
          }).then(data => {
            if (data.result === "success") {
              Toast('验证码已发送，请注意查收')
              jishi();
            } else {
              Toast(data.message)
            }
          })
        })
      }
    })
  }, 200);
}
const logOut = () => {
  clearCookie('token')
}
/**
 * @param {请求url} url
 * @param {请求参数} data
 */


const get = opt => {
  if (!opt.data) {
    opt.data = {}
  }
  opt.params = opt.data
  opt.data = {}
  if (!opt.hasOwnProperty('requestType')) {
    opt.requestType = 1
  }
  opt.params.v = new Date().getTime()
  return http({
    //这里是你自己的请求方式、url和data参数
    method: 'get',
    ...opt

  })
}
const post = opt => {
  if (!opt.data) {
    opt.data = {}
  }
  if (!opt.hasOwnProperty('requestType')) {
    opt.requestType = 1
  }
  opt.data.v = new Date().getTime()
  return http({
    //这里是你自己的请求方式、url和data参数
    method: 'post',
    ...opt
  })
}
const initLogin = ({ success, fail }) => {
  if (isWeixin()) {
    getWXEvn({
      //如果是小程序
      isMiniApp: () => {
        setCookie("token", getQueryString("access_token"), 365 * 24 * 60 * 60);
        setCookie("userId", getQueryString("userId"), 365 * 24 * 60 * 60);
        success && success()
      },
      //如果是公众号网页
      isWeixinNotMiniApp: () => {
        if (!getCookie("token") || getCookie("token") === "") {
          fail && fail()
        } else {
          success && success()
        }
      }
    });
  } else if (isBangBangApp()) {
    //在app中
    const timer = setInterval(function () {
      if (isAndroid()) {
        if (window.synopsis.getUserInfo) {
          clearInterval(timer);
          window.synopsis.getUserInfo();
        }
      } else if (isIOS()) {
        if (window.webkit.messageHandlers.getUserInfo) {
          clearInterval(timer);
          window.webkit.messageHandlers.getUserInfo.postMessage("");
        }
      }
    }, 1000 / 60);
    window.sendUserInfo = (token, userId, userRole) => {
      setCookie("token", token, 365 * 24 * 60 * 60);
      setCookie("userId", userId, 365 * 24 * 60 * 60);
      success && success()
    };
  } else {
    if (!getCookie("token") || getCookie("token") === "") {
      fail && fail()
    } else {
      success && success()
    }
  }
}
export {
  get,
  post,
  toLogin,
  initLogin,
  openLoginPop,
  logOut,
}
